import React from 'react';

interface IconProps {
	className?: string;
	width?: number;
	height?: number;
}

const LinkedInBusiness = ({ className, width = 20, height = 20 }: IconProps) => {
	return (
		<svg
			className={className}
			fill="currentColor"
			height={height}
			viewBox="0 0 20 20"
			width={width}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M0 1.43267C0 0.641641 0.657515 0 1.46864 0H18.5314C19.3425 0 20 0.641644 20 1.43268V18.5673C20 19.3586 19.3425 20 18.5314 20L1.46864 20C0.657515 20 0 19.3586 0 18.5673V1.43267ZM6.17922 16.7421V7.71095H3.17745V16.7421H6.17922ZM4.67832 6.4779C5.7251 6.4779 6.37664 5.78441 6.37664 4.91775C6.35713 4.03159 5.7251 3.35734 4.69818 3.35734C3.67136 3.35734 3 4.03159 3 4.91775C3 5.78441 3.65139 6.4779 4.65876 6.4779H4.67832ZM10.8142 16.7421V11.6987C10.8142 11.4288 10.8338 11.1592 10.913 10.9662C11.13 10.4269 11.6239 9.86838 12.4532 9.86838C13.5394 9.86838 13.9739 10.6966 13.9739 11.9106V16.7421H16.9754V11.5638C16.9754 8.7898 15.4945 7.49903 13.5196 7.49903C11.9272 7.49903 11.2133 8.37421 10.8143 8.98959V9.0207H10.7943C10.8009 9.0104 10.8076 9.00003 10.8143 8.98959V7.71095H7.81258C7.85197 8.55837 7.81258 16.7421 7.81258 16.7421H10.8142Z" />
		</svg>
	);
};

export default LinkedInBusiness;
